import React from 'react';
import CompanyText from '../../global/layout/CompanyText';

// import { FaMapMarkerAlt, FaGlobe } from 'react-icons/fa';

interface allProps {
  data: any;
}

const AboutCompany = (props: allProps) => {
  const companyDetails = props.data.companyId;

  const sections = companyDetails?.sectionTitle.filter(
    (title: string) => title
  );

  return (
    <div className='p-4'>
      <div className='grid grid-cols-6'>
        <div className='col-span-6 sm:col-span-4 space-y-4'>
          {sections.map((title: string, index: number) => {
            return (
              <div>
                <p className='font-semibold lg:text-xl'>{title}</p>
                <div className='mt-2 lg:pr-4 text-justify'>
                  {companyDetails.sectionContent
                    .filter((content: any) => content.sectionNumber === index)
                    .map((content: any, index: number) => {
                      return (
                        <CompanyText
                          key={index}
                          contentType={content.contentType}
                          contentToPublish={content.contentToPublish}
                        />
                      );
                    })}
                </div>
              </div>
            );
          })}
        </div>
        <div className='mt-2 col-span-6 sm:col-span-2 '>
          <div className='border border-primary-light rounded-2xl p-4'>
            <div>Highlights:</div>
            <div className='flex mt-1 items-center'>
              <div className='mr-2 mt-1'>
                <svg
                  width='24'
                  height='24'
                  viewBox='0 0 24 24'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M12 11.5C11.337 11.5 10.7011 11.2366 10.2322 10.7678C9.76339 10.2989 9.5 9.66304 9.5 9C9.5 8.33696 9.76339 7.70107 10.2322 7.23223C10.7011 6.76339 11.337 6.5 12 6.5C12.663 6.5 13.2989 6.76339 13.7678 7.23223C14.2366 7.70107 14.5 8.33696 14.5 9C14.5 9.3283 14.4353 9.65339 14.3097 9.95671C14.1841 10.26 13.9999 10.5356 13.7678 10.7678C13.5356 10.9999 13.26 11.1841 12.9567 11.3097C12.6534 11.4353 12.3283 11.5 12 11.5ZM12 2C10.1435 2 8.36301 2.7375 7.05025 4.05025C5.7375 5.36301 5 7.14348 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 7.14348 18.2625 5.36301 16.9497 4.05025C15.637 2.7375 13.8565 2 12 2Z'
                    fill='black'
                  />
                </svg>
              </div>
              <div>{companyDetails.country}</div>
            </div>
            {companyDetails.industryId && (
              <div className='flex mt-1 items-center'>
                <div className='mr-2 mt-1'>
                  <svg
                    width='24'
                    height='24'
                    viewBox='0 0 24 24'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M12.0001 8C13.0609 8 14.0784 8.42143 14.8285 9.17157C15.5787 9.92172 16.0001 10.9391 16.0001 12C16.0001 13.0609 15.5787 14.0783 14.8285 14.8284C14.0784 15.5786 13.0609 16 12.0001 16C10.9392 16 9.9218 15.5786 9.17166 14.8284C8.42151 14.0783 8.00008 13.0609 8.00008 12C8.00008 10.9391 8.42151 9.92172 9.17166 9.17157C9.9218 8.42143 10.9392 8 12.0001 8ZM12.0001 10C11.4697 10 10.9609 10.2107 10.5859 10.5858C10.2108 10.9609 10.0001 11.4696 10.0001 12C10.0001 12.5304 10.2108 13.0391 10.5859 13.4142C10.9609 13.7893 11.4697 14 12.0001 14C12.5305 14 13.0392 13.7893 13.4143 13.4142C13.7894 13.0391 14.0001 12.5304 14.0001 12C14.0001 11.4696 13.7894 10.9609 13.4143 10.5858C13.0392 10.2107 12.5305 10 12.0001 10ZM10.0001 22C9.75008 22 9.54008 21.82 9.50008 21.58L9.13008 18.93C8.50008 18.68 7.96008 18.34 7.44008 17.94L4.95008 18.95C4.73008 19.03 4.46008 18.95 4.34008 18.73L2.34008 15.27C2.21008 15.05 2.27008 14.78 2.46008 14.63L4.57008 12.97L4.50008 12L4.57008 11L2.46008 9.37C2.27008 9.22 2.21008 8.95 2.34008 8.73L4.34008 5.27C4.46008 5.05 4.73008 4.96 4.95008 5.05L7.44008 6.05C7.96008 5.66 8.50008 5.32 9.13008 5.07L9.50008 2.42C9.54008 2.18 9.75008 2 10.0001 2H14.0001C14.2501 2 14.4601 2.18 14.5001 2.42L14.8701 5.07C15.5001 5.32 16.0401 5.66 16.5601 6.05L19.0501 5.05C19.2701 4.96 19.5401 5.05 19.6601 5.27L21.6601 8.73C21.7901 8.95 21.7301 9.22 21.5401 9.37L19.4301 11L19.5001 12L19.4301 13L21.5401 14.63C21.7301 14.78 21.7901 15.05 21.6601 15.27L19.6601 18.73C19.5401 18.95 19.2701 19.04 19.0501 18.95L16.5601 17.95C16.0401 18.34 15.5001 18.68 14.8701 18.93L14.5001 21.58C14.4601 21.82 14.2501 22 14.0001 22H10.0001ZM11.2501 4L10.8801 6.61C9.68008 6.86 8.62008 7.5 7.85008 8.39L5.44008 7.35L4.69008 8.65L6.80008 10.2C6.40008 11.37 6.40008 12.64 6.80008 13.8L4.68008 15.36L5.43008 16.66L7.86008 15.62C8.63008 16.5 9.68008 17.14 10.8701 17.38L11.2401 20H12.7601L13.1301 17.39C14.3201 17.14 15.3701 16.5 16.1401 15.62L18.5701 16.66L19.3201 15.36L17.2001 13.81C17.6001 12.64 17.6001 11.37 17.2001 10.2L19.3101 8.65L18.5601 7.35L16.1501 8.39C15.3801 7.5 14.3201 6.86 13.1201 6.62L12.7501 4H11.2501Z'
                      fill='black'
                    />
                  </svg>
                </div>

                <div>{companyDetails.industryId?.title}</div>
              </div>
            )}
            <div className='flex mt-1 items-center'>
              <div className='mr-2 mt-1 '>
                <svg
                  width='24'
                  height='24'
                  viewBox='0 0 24 24'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M16.36 14C16.44 13.34 16.5 12.68 16.5 12C16.5 11.32 16.44 10.66 16.36 10H19.74C19.9 10.64 20 11.31 20 12C20 12.69 19.9 13.36 19.74 14M14.59 19.56C15.19 18.45 15.65 17.25 15.97 16H18.92C17.96 17.65 16.43 18.93 14.59 19.56ZM14.34 14H9.66C9.56 13.34 9.5 12.68 9.5 12C9.5 11.32 9.56 10.65 9.66 10H14.34C14.43 10.65 14.5 11.32 14.5 12C14.5 12.68 14.43 13.34 14.34 14ZM12 19.96C11.17 18.76 10.5 17.43 10.09 16H13.91C13.5 17.43 12.83 18.76 12 19.96ZM8 8H5.08C6.03 6.34 7.57 5.06 9.4 4.44C8.8 5.55 8.35 6.75 8 8ZM5.08 16H8C8.35 17.25 8.8 18.45 9.4 19.56C7.57 18.93 6.03 17.65 5.08 16ZM4.26 14C4.1 13.36 4 12.69 4 12C4 11.31 4.1 10.64 4.26 10H7.64C7.56 10.66 7.5 11.32 7.5 12C7.5 12.68 7.56 13.34 7.64 14M12 4.03C12.83 5.23 13.5 6.57 13.91 8H10.09C10.5 6.57 11.17 5.23 12 4.03ZM18.92 8H15.97C15.65 6.75 15.19 5.55 14.59 4.44C16.43 5.07 17.96 6.34 18.92 8ZM12 2C6.47 2 2 6.5 2 12C2 14.6522 3.05357 17.1957 4.92893 19.0711C5.85752 19.9997 6.95991 20.7362 8.17317 21.2388C9.38642 21.7413 10.6868 22 12 22C14.6522 22 17.1957 20.9464 19.0711 19.0711C20.9464 17.1957 22 14.6522 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7362 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2Z'
                    fill='black'
                  />
                </svg>
              </div>
              <a
                href={companyDetails.website}
                target='_blank'
                rel='noreferrer noopener'
                className='break-all text-sm text-primary font-semibold'
              >
                {companyDetails.website}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutCompany;
